const { BASE_URL } = require("./client");

const GET_USER_COUNT = BASE_URL + "/user/count";
const GET_USER_APPLIED = BASE_URL + "/api/applycourse/";
const GET_ALL_PROJECTS = BASE_URL + '/api/get/projects';

export { GET_USER_COUNT , GET_USER_APPLIED , GET_ALL_PROJECTS};
